import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import api from '../api/axiosConfig';

// Registrasi komponen Chart.js yang akan kita gunakan
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const JadwalServisChart = () => {
  const [chartData, setChartData] = useState({
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
    datasets: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const { data } = await api.get('/api/dashboard/jadwal-servis-chart');
        setChartData({
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
          datasets: [
            {
              label: 'Jumlah Jadwal Servis',
              data: data,
              backgroundColor: 'rgba(54, 162, 235, 0.6)', // Warna biru
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Gagal mengambil data chart Jadwal Servis:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChartData();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Sembunyikan legenda
      },
      title: {
        display: true,
        text: 'Jadwal Servis per Bulan',
        font: {
          family: 'Poppins',
          size: 16,
        },
        color: '#333'
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
            stepSize: 1
        }
      },
    },
  };

  if (loading) {
    return <p>Memuat data grafik...</p>;
  }

  return <Bar options={options} data={chartData} />;
};

export default JadwalServisChart;